goog.provide("shadow.js.shim.module$d3_zoom");
goog.provide("module$shadow_js_shim_module$d3_zoom");
shadow.js.shim.module$d3_zoom = shadow.js.nativeProvides["d3-zoom"] = shadow$bridge("d3-zoom");
module$shadow_js_shim_module$d3_zoom.default = shadow.js.shim.module$d3_zoom;
